
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employer/payments-and-invoices",
      function () {
        return require("private-next-pages/employer/payments-and-invoices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employer/payments-and-invoices"])
      });
    }
  